// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as LoadAssistInfoEntityMapper from "../../entity-mapper/LoadAssistInfoEntityMapper.bs.js";

var execute = LoadAssistInfoEntityMapper.execute;

var LoadAssistInfoResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var LoadAssistInfoResponseConverter = partial_arg(LoadAssistInfoResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  LoadAssistInfoResponseConverterConfig ,
  LoadAssistInfoResponseConverter ,
  
}
/* LoadAssistInfoResponseConverter Not a pure module */
